<script setup lang="ts">
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    defineProps<{
        month: number;
    }>();
</script>

<template>
    {{ t(`salary.sheets.months.${month}`) }}
</template>
